import locationAddressValidator from 'forms/shared/validators/models/location/models/address';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import currencyModelValidator from 'forms/shared/validators/models/currency';
import { REQUIRED } from 'constants/errors';
import { accountNumberPattern } from 'constants/patterns';
import { isPVQForm } from 'helpers/form';
import { hasYesOrNo } from 'models/validate';
import { FinancialDelinquentItemModel } from '../types';

const infractionOptions = ['Alimony', 'Judgement', 'Lien', 'Federal'];

export const financialDelinquentItemValidator: ValidateJSModel<FinancialDelinquentItemModel> = {
  Name: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) { return {}; }
    if (options?.requireFinancialDelinquentName) {
      return { hasValue: true };
    }

    return {};
  },

  Infractions: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) { return {}; }
    if (options?.requireFinancialDelinquentInfraction) {
      return {
        array: {
          validator: {
            inclusion: infractionOptions,
          },
          length: { minimum: 1, message: REQUIRED },
        },
      };
    }

    return {};
  },

  AccountNumber: (value, attributes) => {
    if (attributes?.AccountNumberNotApplicable?.applicable === false) { return {}; }
    return {
      hasValue: {
        validator: {
          format: {
            pattern: accountNumberPattern,
            message: 'error.delinquent.accountNumber.pattern',
          },
        },
      },
    };
  },
  AccountNumberExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) { return {}; }
    if (attributes?.AccountNumberNotApplicable?.applicable === false) {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  PropertyType: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) { return {}; }
    return { hasValue: true };
  },

  Amount: {
    model: {
      validator: currencyModelValidator,
    },
  },

  Reason: { hasValue: true },

  Status: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) { return {}; }
    return { hasValue: true };
  },

  Date: (value, attributes, attributeName, options) => ({
    presence: true,
    date: { requireDay: false, earliest: options?.applicantBirthdate, latest: DEFAULT_LATEST },
  }),

  Resolved: (value, attributes, attributeName, options) => {
    if (attributes?.ResolvedNotApplicable?.applicable === false || ((isPVQForm(options?.formType)) && attributes?.HasActionTaken?.value === 'Yes')) { return {}; }

    return {
      presence: true,
      date: {
        requireDay: false,
        latest: DEFAULT_LATEST,
        earliest: attributes?.Date,
        tooEarly: 'error.date.financialDelinquencyResolvedDateTooEarly',
      },
    };
  },

  CourtName: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) { return {}; }
    if (attributes?.CourtNameNotApplicable?.applicable === false) { return {}; }
    return { hasValue: true };
  },
  CourtNameExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) { return {}; }
    if (attributes?.CourtNameNotApplicable?.applicable === false) {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  CourtAddress: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) { return {}; }
    if (attributes?.CourtAddressNotApplicable?.applicable === false) { return {}; }
    return {
      presence: true,
      location: { validator: locationAddressValidator },
    };
  },
  CourtAddressExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) { return {}; }
    if (attributes?.CourtAddressNotApplicable?.applicable === false) {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  Description: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) { return {}; }
    return { hasValue: true };
  },

  AmountEstimated: {},

  ResolvedNotApplicable: {},
  AccountNumberNotApplicable: {},
  CourtNameNotApplicable: {},
  CourtAddressNotApplicable: {},
  NoActionsTaken: {},
  HasActionTaken: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },
   ActionsTaken: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) 
      && attributes?.NoActionsTaken?.applicable === true
    && attributes.HasActionTaken.value === 'Yes') {
    return { hasValue: true };
    }
    return {};
  },

    ActionsTakenNoneExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) 
      && attributes?.NoActionsTaken?.applicable === false
    && attributes.HasActionTaken.value === 'Yes') {
      return { hasValue: true };
    }
    return {};
  },

 

  DebtExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { hasValue: true };
    }
    return {};
  },

};
